/**
 * 解析 URL 并返回 key 对应的 value
 * 备注：没有兼容性要求的话，可以使用 URLSearchParams （不支持 IE11）更方便
 * @param {*} url URL 链接
 * @param {*} paraName 要获取的 key
 * @returns 返回对应的 value
 */
import { getQuery } from 'steamer-browserutils';

export function getUrlParam(url, paraName) {
    if (!url) {
        return '';
    }
    const arrObj = url.split('?');
    if (arrObj.length > 1) {
        const arrPara = arrObj[1].split('&');
        let arr;

        for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=');
            if (arr !== null && arr[0] === paraName) {
                return arr[1];
            }
        }
    }
    return '';
}

export function getEnvParam() {
    if (getQuery('route_ip')) {
        return {
            route_ip: getQuery('route_ip'),
            room_route_ip: getQuery('room_route_ip'),
        };
    }

    return {};
}

export function addUrlParam(uri, parameters) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in parameters) {
        if (Object.prototype.hasOwnProperty.call(parameters, key)) {
            const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
            const value = parameters[key];
            const separator = uri.indexOf('?') !== -1 ? '&' : '?';

            if (uri.match(re)) {
                uri = uri.replace(re, `$1${key}=${value}$2`);
            } else {
                uri = `${uri + separator + key}=${value}`;
            }
        }
    }
    return uri;
}

export function removeURLParameter(url, parameter) {
    // prefer to use l.search if you have a location/link object
    const urlparts = url.split('?');
    if (urlparts.length >= 2) {
        const prefix = `${encodeURIComponent(parameter)}=`;
        const pars = urlparts[1].split(/[&;]/g);

        // reverse iteration as may be destructive
        for (let i = pars.length - 1; i >= 0; i--) {
            // idiom for string.startsWith
            if (pars[i] && pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        const result = urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
        return result;
    }
    return url;
}

export function updateQueryStringParameter(uri, parameters) {
    for (const key in parameters) {
        if (Object.prototype.hasOwnProperty.call(parameters, key)) {
            const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
            const value = parameters[key];
            const separator = uri.indexOf('?') !== -1 ? '&' : '?';
            if (uri.match(re)) {
                uri = uri.replace(re, `$1${key}=${value}$2`);
            } else {
                uri = `${uri + separator + key}=${value}`;
            }
        }
    }
    return uri;
}

export function getUrlParameter(paramKey: string) {
    let sURLVariables;
    let i;
    let sParameterName;
    const sPageURL = window.location.search.substring(1);
    if (sPageURL) {
        sURLVariables = sPageURL.split('&');
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === paramKey) return sParameterName[1];
        }
    }
    return null;
}

export function getQuerySearchParams(key: string) {
    if (!window.URL || !('searchParams' in window.URL.prototype)) {
        return '';
    }
    const query = new URL(window.location as unknown as string).searchParams;
    return query.get(key) || '';
}
